import { styles as textStyles } from 'design-system/Text';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { isWeb } from '../../../constants';
/** Style for the dollar price `MoneyTextInput` on the limit/stop price and stock alert screens. */
export const usePriceInputStyle = (isFocused) => {
    const styles = useStyles(styleSet);
    return [styles.textInput, isWeb && styles.textInputWeb, isWeb && isFocused && styles.textInputFocused];
};
const styleSet = createStyleSheets((colors) => ({
    textInput: {
        ...textStyles.Numbers_24,
        color: colors.text.primary,
    },
    textInputWeb: {
        borderWidth: rem(1),
        borderRadius: rem(8),
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
        caretColor: colors.text.selection,
        borderColor: colors.borders.divider,
        backgroundColor: colors.cards.onDark,
    },
    textInputFocused: {
        borderColor: colors.elements.brand,
    },
}));
